import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { LEDGER_CONTRACT_NOTE } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
class LedgerContractNoteActions extends OnePlatformCommonActions {
    contractNote(contractNote, type) {
        this.dispatch({
            type: LEDGER_CONTRACT_NOTE,
            payload: { contractNote },
            reducerName: type,
        });
    }
}
export default LedgerContractNoteActions;
